import React, { useState } from "react";
import { SET_BANK_INFO } from "../../../../utilities/constants";
import { useSelector, useDispatch } from "react-redux";
import BottomTabNav from "../../customs/BottomTabNav";
import axios from "axios";
import Input from "../../customs/Input";

export default function BankInfo(props) {
  const [bankInfo, setBankInfo] = useState({});
  const { id } = useSelector((state) => state.restaurant);
  const dispatch = useDispatch();
  const updateChef = async () => {
    const response = await axios.put(`/api/newrest/${id}`, { bankInfo })
    alert('Documents uploaded')
  }

  const handleBack = (e) => {
    e.preventDefault();
    props.goToStep(4);
  };
  const onChangeText = (e) => {
    const { name, value } = e.target;
    setBankInfo((prevState) => ({ ...prevState, [name]: value }));
  };
  return (
    <fieldset>
      <div className="row mt-2">
        <div className="col-4">
          <Input
            label="Account name"
            required={true}
            name="account_name"
            type="text"
            handler={onChangeText}
          />
        </div>
        <div className="col-4">
          <Input
            label="ACCOUNT NUMBER"
            required={true}
            name="account_number"
            type="text"
            handler={onChangeText}
          />
        </div>
        <div className="col-4">
          <Input
            label="CONFIRM ACCOUNT NUMBER"
            required={true}
            name="confirm_account_number"
            type="text"
            handler={onChangeText}
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-4">
          <Input
            label="bank name"
            required={true}
            name="bank_name"
            type="text"
            handler={onChangeText}
          />
        </div>
        <div className="col-4">
          <Input
            label="Branch #"
            required={true}
            name="branch_number"
            type="text"
            handler={onChangeText}
          />
        </div>
        <div className="col-4">
          <Input
            label="Institution/Routing #"
            required={true}
            name="institution_number"
            type="text"
            handler={onChangeText}
          />
        </div>
      </div>
      <BottomTabNav currentStep={5} props={props} data={bankInfo} handler={updateChef} />
    </fieldset>
  );
}
